import { render } from "./Products.vue?vue&type=template&id=4d04dfe2&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=4d04dfe2&scoped=true&lang=css"

import exportComponent from "E:\\Andrei\\munca\\Isoletta\\isoletta-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d04dfe2"]])

export default __exports__